'use strict';

var _ = require('lodash');
var SpecialEventsGridService = function SpecialEventsGridService(seasonalityConstants) {
  var TYPES = seasonalityConstants.SPECIAL_EVENT_TYPES;
  function setStructureWithOldValues($scope, loadedData, rowid) {
    var columns = $scope.jqxGridSettings.columns;
    loadedData[rowid]._old = {};
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  function addRow($scope) {
    var loadedData = $scope.localData;
    loadedData.unshift({
      isRowRemovable: true,
      isRowEditable: true
    });
    setStructureWithOldValues($scope, loadedData, 0);
    $scope.updateData(loadedData);
  }
  function getNextOriginalRowId(localData) {
    return _.reduce(localData, function (nextOriginalRowId, row) {
      if (row.originalRowId && row.originalRowId > nextOriginalRowId) {
        return _.clone(row.originalRowId) + 1;
      } else {
        return nextOriginalRowId;
      }
    }, 0);
  }
  function duplicateRow($scope, oldRow) {
    var loadedData = $scope.localData;
    var newRow = _.clone(oldRow);
    newRow.originalRowId = getNextOriginalRowId($scope.localData);
    loadedData.unshift(newRow);
    setStructureWithOldValues($scope, loadedData, 0);
    $scope.updateData(loadedData);
  }
  function rowSelectionHandler($scope, selectedRows) {
    $scope.isDuplicateButtonShown = selectedRows.length === 1;
    _.forEach(selectedRows, function (row) {
      if (isUserExclusionEvent(row) || !row.isRowEditable) {
        $scope.isDuplicateButtonShown = false;
        return false;
      }
    });
    $scope.isDeleteButtonShown = selectedRows.length > 0 && _.every(selectedRows, function (element) {
      return element.isRowRemovable;
    });
    $scope.selectedRows = selectedRows;
  }
  function isUserExclusionEvent(data) {
    return data.eventType === TYPES.EXCLUDED && data.eventName === TYPES.USER_EXCLUDED;
  }
  function processUserExclusionData(eventsData, exclusionData) {
    removeUserExclusionData(eventsData, exclusionData);
    addUserExclusionData(eventsData, exclusionData);
  }
  function removeUserExclusionData(eventsData, data) {
    var loadedData = eventsData;
    var removeStartDateArray = _.map(data.remove, 'startDate');
    var indexesToRemove = _.map(loadedData, function (row, index) {
      if (isUserExclusionEvent(row) && row.market === data.market && _.includes(removeStartDateArray, row.startDate)) {
        return index;
      }
    });
    _.remove(loadedData, function (value, index) {
      return _.includes(indexesToRemove, index);
    });
  }
  function addUserExclusionData(eventsData, data) {
    var loadedData = eventsData;
    _.forEach(data.add, function (row) {
      loadedData.unshift({
        market: data.market,
        eventType: TYPES.EXCLUDED,
        eventName: TYPES.USER_EXCLUDED,
        startDate: row.startDate,
        endDate: row.endDate,
        isRowRemovable: true,
        isRowEditable: false
      });
    });
  }
  function addSpecialEventsData($scope, data) {
    $scope.updateData(data);
  }
  return {
    addRow: addRow,
    duplicateRow: duplicateRow,
    rowSelectionHandler: rowSelectionHandler,
    processUserExclusionData: processUserExclusionData,
    addSpecialEventsData: addSpecialEventsData,
    isUserExclusionEvent: isUserExclusionEvent
  };
};
SpecialEventsGridService.$inject = ['SeasonalityConstants'];
module.exports = SpecialEventsGridService;